import request from '@/utils/request'

// 获取部门列表
export function getList(params) {
  return request.get('/department/list', { params })
}

// 创建部门信息
export function createOne(data) {
  return request.post('/department/create', data)
}

// 更新部门信息
export function updateOne(data) {
  return request.post('/department/update', data)
}

// 删除部门信息
export function deleteOne(data) {
  const url = '/department/delete/' + data.id
  return request.get(url)
}
